'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ScalesViewportFactory = function ScalesViewportFactory(mapService) {
  var ScalesViewport = function ScalesViewport(params, data, range) {
    var metricKey = mapService.getMapComponent('scaleMetric');
    /**
     * In case when there's no d.m3 or d.m4 use zero (ex. postDepartureMode)
     * @param d
     * @returns {Array}
     */
    var yMin = d3.min(data, function (d) {
      return Math.min(0, d[metricKey]);
    });
    var yMax = d3.max(data, function (d) {
      return Math.max(0, d[metricKey]);
    });

    // the brush can modify the visible range of elements
    data = data.slice(range[0], range[1]);
    var width = calculateWidth();
    var offset = (params.width - width) / 2;
    var x = d3.scale.ordinal().domain(_.map(data, 'runNumber')).rangeBands([offset, width + offset], 0.1, 0.05);
    var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
    function calculateWidth() {
      var width = params.width;
      var dataLength = data.length;
      if (params.width / dataLength > params.maxGroupWidth) {
        width = params.maxGroupWidth * dataLength;
      }
      return width;
    }
    return {
      xScale: x,
      yScale: y
    };
  };
  return ScalesViewport;
};
ScalesViewportFactory.$inject = ['SnapshotDatesMapDataToChartComponentsService'];
module.exports = ScalesViewportFactory;